<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick" class="cpTab">
      <el-tab-pane label="便携式车载式" name="portable">
        <div>
          <el-row class="search-add" :gutter="10">
            <el-col :span="4">
              <el-input placeholder="机构名称" v-model="insName"></el-input>
            </el-col>
            <el-col :span="4">
              <el-input placeholder="设备编号" v-model="devId"></el-input>
            </el-col>
            <el-col :span="4">
              <el-input
                placeholder="个人超级管理员手机号码"
                v-model="mobile"
              ></el-input>
            </el-col>

            <el-col :span="10">
              <el-button type="primary" icon="el-icon-search" @click="search"
                >搜索</el-button
              >
            </el-col>
            <el-col :span="2">
              <el-button type="success" @click="add">添加设备</el-button>
            </el-col>
          </el-row>
          <el-button type="primary" @click="onDelete('list', radio)"
            >批量删除</el-button
          >
          <el-checkbox
            style="margin-left: 20px"
            @change="handleAyncChange('all', $event)"
            v-model="allAync2"
          ></el-checkbox>
          <span style="margin-left: 5px" type="primary"
            >同步所有机构下的所有设备</span
          >
          <el-table
            default-expand-all
            row-key="activeId"
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          >
            <el-table-column label="机构名称/个人管理手机号">
              <template slot-scope="scope">
                <el-checkbox
                  @change="handleCheckChange(scope.row.activeId, $event)"
                  v-model="radio[scope.row.activeId]"
                ></el-checkbox>
                {{ scope.row.ownerName || scope.row.activeId }}
              </template>
            </el-table-column>
            <el-table-column label="绑定时间">
              <template slot-scope="scope">
                {{ scope.row.bindingTime }}
              </template>
            </el-table-column>
            <el-table-column label="个人/机构">
              <template slot-scope="scope">
                {{
                  scope.row.userType == 0
                    ? "机构"
                    : scope.row.activeId && !scope.row.ownerName
                    ? ""
                    : "个人"
                }}
                <el-checkbox
                  style="margin-left: 5px"
                  v-show="!!scope.row.ownerName"
                  @change="handleAyncChange('single', scope.row)"
                  v-model="scope.row.syncFlag"
                ></el-checkbox>
                <span style="margin-left: 2px" v-show="!!scope.row.ownerName"
                  >同步本{{
                    scope.row.userType == 0
                      ? "机构"
                      : scope.row.activeId && !scope.row.ownerName
                      ? ""
                      : "个人"
                  }}下所有设备</span
                >
              </template>
            </el-table-column>

            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="onDelete('sel', scope.row.activeId + '')"
                  >{{
                    scope.row.activeId && !scope.row.ownerName
                      ? "删除"
                      : "全部删除"
                  }}
                </el-button>
                <el-button type="text" size="small" @click="onData(scope.row)">
                  {{ statusCode[scope.row.status] && "数据补传" }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="tableDel-Page">
            <Pagination
              :params="portablePagin"
              @pageBind="getPortableList"
            ></Pagination>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="网关式" name="gateway">
        <div>
          <el-row class="search-add" :gutter="10">
            <el-col :span="4">
              <el-input placeholder="机构名称" v-model="insName"></el-input>
            </el-col>
            <el-col :span="4">
              <el-input placeholder="设备编号" v-model="devId"></el-input>
            </el-col>
            <el-col :span="4">
              <el-input
                placeholder="个人超级管理员手机号码"
                v-model="mobile"
              ></el-input>
            </el-col>

            <el-col :span="10">
              <el-button type="primary" icon="el-icon-search" @click="search"
                >搜索</el-button
              >
            </el-col>
            <el-col :span="2">
              <el-button type="success" @click="add">添加设备</el-button>
            </el-col>
          </el-row>
          <el-button type="primary" @click="onDelete('list', radio)"
            >批量删除</el-button
          >
          <el-checkbox
            style="margin-left: 20px"
            @change="handleAyncChange('all', $event)"
            v-model="allAync2"
          ></el-checkbox>
          <span style="margin-left: 5px" type="primary"
            >同步所有机构下的所有设备</span
          >
          <el-table
            default-expand-all
            row-key="activeId"
            ref="multipleTable"
            :data="GTableData"
            tooltip-effect="dark"
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          >
            <el-table-column label="机构名称/个人管理手机号">
              <template slot-scope="scope">
                <el-checkbox
                  @change="handleCheckChange(scope.row.activeId, $event)"
                  v-model="radio[scope.row.activeId]"
                ></el-checkbox>
                {{ scope.row.ownerName || scope.row.activeId }}
              </template>
            </el-table-column>
            <el-table-column label="绑定时间">
              <template slot-scope="scope">
                {{ scope.row.bindingTime }}
              </template>
            </el-table-column>
            <el-table-column label="个人/机构">
              <template slot-scope="scope">
                {{
                  scope.row.userType == 0
                    ? "机构"
                    : scope.row.activeId && !scope.row.ownerName
                    ? ""
                    : "个人"
                }}
                <el-checkbox
                  style="margin-left: 5px"
                  v-show="!!scope.row.ownerName"
                  @change="handleAyncChange('single', scope.row)"
                  v-model="scope.row.syncFlag"
                ></el-checkbox>
                <span style="margin-left: 2px" v-show="!!scope.row.ownerName"
                  >同步本{{
                    scope.row.userType == 0
                      ? "机构"
                      : scope.row.activeId && !scope.row.ownerName
                      ? ""
                      : "个人"
                  }}下所有设备</span
                >
              </template>
            </el-table-column>

            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="onDelete('sel', scope.row.activeId + '')"
                  >{{
                    scope.row.activeId && !scope.row.ownerName
                      ? "删除"
                      : "全部删除"
                  }}
                </el-button>
                <el-button type="text" size="small" @click="onData(scope.row)">
                  {{ statusCode[scope.row.status] && "数据补传" }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="tableDel-Page">
            <Pagination
              :params="gatewayPagin"
              @pageBind="getGateWayList"
            ></Pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      :visible.sync="dataDialogVisible"
      :data="rowData"
      title="数据补传"
      width="30%"
      center
      @closed="closed"
    >
      <el-form
        label-width="80px"
        :model="formUpdate"
        :rules="rules"
        ref="formUpdate"
      >
        <el-form-item label="设备编号" prop="devId">
          <el-input v-model="formUpdate.devId" disabled></el-input>
        </el-form-item>
        <el-form-item label="起始日期" required prop="startTime">
          <el-date-picker
            v-model="formUpdate.startTime"
            type="datetime"
            placeholder="选择起始日期时间"
            style="width: 100%"
            value-format="timestamp"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期" required prop="endTime">
          <el-date-picker
            v-model="formUpdate.endTime"
            type="datetime"
            placeholder="选择结束日期时间"
            style="width: 100%"
            value-format="timestamp"
            default-time="23:59:59"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="ConfirmLoading"
          @click="submitForm('formUpdate')"
          >上传</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { STATUS_CODE } from "@/constant";
export default {
  name: "CPDevice",
  props: {
    apiHost: {
      path: "canpan",
      urlQuery: "?isCP=true",
    },
  },
  data() {
    return {
      statusCode: STATUS_CODE,
      activeName: "portable",
      dataDialogVisible:false,
      ConfirmLoading: false,
      rowData: {},
      portablePagin: {
        pageNum: 1,
        size: 10,
        total: 0,
        isDefaultPageSizes: true,
      },
      gatewayPagin: {
        pageNum: 1,
        size: 10,
        total: 0,
        isDefaultPageSizes: true,
      },

      mchId: +this.$route.params.id,
      allAync: false,
      allAync2: false,
      disAds: [],
      insName: "",
      devId: "",
      mobile: "",
      radio: {},
      preRadio: {},
      tableData: [],
      multipleSelection: [],
      GTableData: [],
      formUpdate: {
        devId: "",
        startTime: "",
        endTime: "",
      },
      rules: {
        startTime: [{ required: true, message: "请选择", trigger: "blur" }],
        endTime: [{ required: true, message: "请选择", trigger: "blur" }],
      },
    };
  },

  methods: {
    onData(data) {
      this.dataDialogVisible = true;
      this.formUpdate.devId = data.devId;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ConfirmLoading = true;
          this.$http
            .post("/merchant/sync/handPush", this.formUpdate)
            .then((rs) => {
              if (rs.data.code == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.ConfirmLoading = false;
                this.dataDialogVisible = false;
                this.clean();
              } else {
                this.$message({
                  message: rs.data.message,
                  type: "error",
                });
                this.ConfirmLoading = false;
              }
            });
        } else {
          this.ConfirmLoading = false;
          return false;
        }
      });
    },
    add() {
      this.$router.push(
        "/api/index/addDevice/" + this.mchId + this.apiHost.urlQuery
      );
    },
    onChangeList(value) {
      if (value === "gateway") {
        this.getGateWayList();
      }
      if (value === "portable") {
        this.getPortableList();
      }
    },
    handleClick(tab) {
      this.insName = "";
      this.devId = "";
      this.mobile = "";
      this.radio = [];
      this.activeName = tab.name;
      this.onChangeList(tab.name);
    },
    search() {
      //搜索
      this.onChangeList(this.activeName);
      if (this.activeName === "gateway") {
        this.getwayPagin.pageNum = 1;
      }
      if (this.activeName === "portable") {
        this.portablePagin.pageNum = 1;
      }
    },

    handleAyncChange(type, val) {
      if (type === "single") {
        let params = {
          userType: val.userType,
          mchId: val.mchId,
          type: val.syncFlag ? 1 : 0,
          insId: val.insId || undefined,
          userId: val.userId || undefined,
        };
        this.$http
          .post(`/${this.apiHost.path}/merchant/sync/single`, params)
          .then((rs) => {
            if (rs.data.code == 0) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.onChangeList(this.activeName);
            } else {
              this.$message({
                message: rs.data.message,
                type: "error",
              });
            }
          });
        return;
      }
      if (
        confirm(
          `确定要${this.allAync ? "取消" : ""}同步所有机构下的所有设备吗？`
        )
      ) {
        this.allAync = !this.allAync;
        this.$http
          .post(`/${this.apiHost.path}/merchant/sync/all/`, {
            mchId: this.mchId,
            type: this.allAync ? 1 : 0,
          })
          .then((rs) => {
            if (rs.data.code == 0) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.onChangeList(this.activeName);
            } else {
              this.$message({
                message: rs.data.message,
                type: "error",
              });
            }
          });
      } else {
        // this.allAync = false;
      }
      console.log("this.allAync", this.allAync);
      this.allAync2 = this.allAync;
    },
    getPortableList() {
      //数据绑定
      let params = {
        page: this.portablePagin.pageNum,
        limit: this.portablePagin.size,
        insName: this.insName,
        mobile: this.mobile,
        mchId: +this.mchId,
      };
      if (this.devId) {
        params.devId = +this.devId;
      }
      // this.radio = {};
      this.$http
        .post(`/${this.apiHost.path}/merchant/devPortableMchPage `, params)
        .then((results) => {
          this.tableData = this.parseList(
            results["data"]["data"]["page"]["records"]
          );
          console.log(this.tableData);
          this.portablePagin.total = results["data"]["data"]["page"]["total"];
        });
    },
    getGateWayList() {
      //数据绑定
      let params = {
        page: this.gatewayPagin.pageNum,
        limit: this.gatewayPagin.size,
        insName: this.insName,
        mobile: this.mobile,
        mchId: +this.mchId,
      };
      if (this.devId) {
        params.devId = +this.devId;
      }
      // this.radio = {};
      this.$http
        .post(`/${this.apiHost.path}/merchant/devGatewayMchPage  `, params)
        .then((results) => {
          this.GTableData = this.parseList(
            results["data"]["data"]["page"]["records"]
          );
          this.portablePagin.total = results["data"]["data"]["page"]["total"];
        });
    },
    onDelete(type, value = "") {
      console.log(type, value);
      let deleteIds = [];
      if (type === "list") {
        Object.keys(value).forEach((key) => {
          if (!key.includes("type:") && value[key]) {
            deleteIds.push(key + "");
          }
        });
      } else {
        if (value.includes("type:")) {
          if (this.activeName === "gateway") {
            this.GTableData.forEach((item) => {
              if (item.activeId === value) {
                if (item.children) {
                  item.children.forEach((item) => {
                    deleteIds.push(item.activeId + "");
                  });
                }
              }
            });
          }
          if (this.activeName === "portable") {
            this.tableData.forEach((item) => {
              if (item.activeId === value) {
                if (item.children) {
                  item.children.forEach((item) => {
                    deleteIds.push(item.activeId + "");
                  });
                }
              }
            });
          }
        } else {
          deleteIds.push(value + "");
        }
      }
      if (deleteIds.length === 0) {
        alert("请先选择要删除的设备");
        return;
      }
      if (
        confirm(
          type !== "list" && value.includes("type:")
            ? "确认要删除该机构下的全部设备吗？"
            : "确认要删除吗？"
        )
      ) {
        console.log("delete", deleteIds, this.tableData);
        let ids = [];
        if (this.activeName === "gateway") {
          this.GTableData.forEach((item) => {
            if (item.children) {
              item.children.forEach((_item) => {
                if (deleteIds.includes(_item.activeId + "")) {
                  ids.push(_item.id);
                }
              });
            }
          });
        }
        if (this.activeName === "portable") {
          this.tableData.forEach((item) => {
            if (item.children) {
              item.children.forEach((_item) => {
                if (deleteIds.includes(_item.activeId + "")) {
                  ids.push(_item.id);
                }
              });
            }
          });
        }
        this.$http
          .put(`/${this.apiHost.path}/merchant/disassociate`, {
            mchId: this.mchId,
            idList: ids,
          })
          .then((rs) => {
            if (rs.data.code == 0) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.onChangeList(this.activeName);
            } else {
              this.$message({
                message: rs.data.message,
                type: "error",
              });
            }
          });
      }
    },
    handleCheckChange(id, v) {
      let parent;
      if (this.activeName === "gateway") {
        parent = this.GTableData.filter((item) => item.activeId === id)[0];
      }
      if (this.activeName === "portable") {
        parent = this.tableData.filter((item) => item.activeId === id)[0];
      }
      let copyRadio = { ...this.radio };
      if (parent) {
        // 没有children不处理父节点
        if (!parent.children) {
          return;
        }
        let ids = parent.children.map((item) => item.activeId);
        ids.forEach((id) => {
          copyRadio[id] = v;
        });
        console.log("copyRadio[", copyRadio);
        this.radio = copyRadio;
        return;
      }
      let _Parent = this.getParent(id, this.tableData);

      if (v) {
        let isAllSelect = true;
        _Parent.children.map((item) => {
          if (
            (!copyRadio[item.activeId] || copyRadio[item.activeId] === false) &&
            isAllSelect
          ) {
            isAllSelect = false;
          }
        });
        if (isAllSelect) {
          copyRadio[_Parent.activeId] = true;
        }
      } else {
        console.log(11);
        copyRadio[_Parent.activeId] = false;
      }
      this.radio = copyRadio;
    },
    getParent(id, list) {
      let parent = null;
      list.forEach((item) => {
        if (item.children) {
          item.children.forEach((_item) => {
            if (_item.activeId === id) {
              parent = item;
            }
          });
        }
      });
      return parent;
    },
    parseList(list) {
      const _list = [...list];
      _list.map((item, idx) => {
        item.activeId = `type:` + new Date().getTime() + idx;
        if (item.devList) {
          item.children = item.devList.map((_item) => {
            _item.activeId = _item.devId;
            return _item;
          });
          delete item.devList;
        }
      });
      return _list;
    },
    diffObj(newValue, oldValue) {
      const diff = {};

      for (let key in newValue) {
        if (newValue.hasOwnProperty(key)) {
          if (
            !oldValue.hasOwnProperty(key) ||
            oldValue[key] !== newValue[key]
          ) {
            diff[key] = newValue[key];
          }
        }
      }

      for (let key in oldValue) {
        if (oldValue.hasOwnProperty(key) && !newValue.hasOwnProperty(key)) {
          diff[key] = undefined;
        }
      }

      return Object.keys(diff).map((item) => [item, diff[item]])[0];
    },
    clean() {
      this.$nextTick(() => {
        if (this.$refs.formUpdate) {
          this.$refs.formUpdate.resetFields();
        }
      });
    },
    closed() {
      this.clean();
    },
  },
  components: { Pagination },
};
</script>
<style>
.el-tabs__nav .el-tabs__item {
  font-size: 16px;
}
</style>
